"use strict";
exports.__esModule = true;
exports.forImmediate = void 0;
var forTime_js_1 = require("./forTime.js");
function forImmediate() {
    // Note: Not using setImmediate because it is non-standard feature only in browser window
    //       @see https://developer.mozilla.org/en-US/docs/Web/API/Window/setImmediate
    return (0, forTime_js_1.forTime)(0);
}
exports.forImmediate = forImmediate;
